/**
 * `<meta>` values shared across layouts. Next REPLACES a parent layout's
 * `metadata.other` rather than merging it, so any segment that adds a tag
 * must re-declare the root's too — they live here so a segment can't drop
 * one by accident.
 */

/** GitLab DAST domain verification — must be on every page DAST may probe. */
export const DAST_VALIDATION_META = {
  'gitlab-dast-validation': 'c87c220b-aec2-46a3-8c89-84182b24d7f9'
} as const

/**
 * Apple's Smart App Banner. Declared only by the internal and technician
 * segment layouts — never the root — so iOS Safari doesn't offer the app on
 * portal (customers aren't launched in the app yet) or on sign-in,
 * invitation and password-reset pages. `app-argument` is refined to the live
 * URL client-side by AppleSmartAppBannerSync.
 */
export const APPLE_APP_ID = '6761316428'
export const SMART_APP_BANNER_META = {
  'apple-itunes-app': `app-id=${APPLE_APP_ID}`
} as const
